// src/services/api.js

import axios from 'axios';

const API_URL = '/api/';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- Interceptor de Peticiones (el que ya teníamos) ---
// Añade el token a cada petición saliente.
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // --- CORRECCIÓN AQUÍ ---
    // Si el error viene de la petición de LOGIN ('/token/'), no intentamos refrescar ni redirigir.
    // Simplemente devolvemos el error para que Login.js muestre el mensaje en rojo.
    if (originalRequest.url.includes('/token/') && !originalRequest.url.includes('/refresh/')) {
        return Promise.reject(error);
    }
    // -----------------------

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        
        // Si no hay refresh token, redirigimos a login
        if (!refreshToken) {
            // Evitamos bucles infinitos: si ya estamos en login, no recargamos
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
            return Promise.reject(error);
        }

        const response = await axios.post(`${API_URL}token/refresh/`, {
          refresh: refreshToken,
        });

        localStorage.setItem('accessToken', response.data.access);
        originalRequest.headers['Authorization'] = `Bearer ${response.data.access}`;
        
        return apiClient(originalRequest);

      } catch (refreshError) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        
        // Solo redirigimos si no estamos ya en la página de login
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;